/**
 * Fixtures de mock para o domínio Bem-Estar Psicossocial.
 * Usadas pelo MockInterceptor durante desenvolvimento local.
 * ⚠️  Dados fictícios. Nenhum dado real de saúde.
 */
import {
  Acolhimento,
  ProntuarioCompleto,
  StatusProprioResponse,
  DashboardAgregado,
} from '../models/bem-estar.models';

export const MOCK_STATUS_PROPRIO: StatusProprioResponse = {
  servidorId: 'a63b0a21-1773-45d2-a7cc-22bd1f2bc88b',
  status: 'EM_ACOMPANHAMENTO',
};

export const MOCK_ACOLHIMENTOS: Acolhimento[] = [
  {
    id: 'f8b2c8c4-e81a-4d22-bc55-1bdcf881ac33',
    servidorId: 'a63b0a21-1773-45d2-a7cc-22bd1f2bc88b',
    nomeServidor: 'SGT PM THIAGO RAMOS SILVA',
    matricula: '819.043-4',
    tipo: 'ENCAMINHADO_SAUDE',
    estado: 'ACOMPANHAMENTO',
    profissionalResponsavelId: '7ccbc8cb-456c-48b2-11ee-33881dfdcc12',
    consentimentoRegistrado: true,
    consentimentoData: '2026-06-01T09:30:00Z',
    indicadorPsicologicoAtual: 'ATIVO_MONITORADO',
    indicadorSocialAtual: 'ATIVO_BEM',
    indicadorValidade: '2026-12-01',
    criadoEm: '2026-05-15T08:00:00Z',
    altaEm: null,
  },
  {
    id: 'a1d3c5e7-b2f4-4a6c-8e0d-1f3a5c7e9b0d',
    servidorId: 'b74c1b32-2884-56e3-b8dd-33ce2g3cd99c',
    nomeServidor: 'CB PM ALINE CRISTINA MOREIRA',
    matricula: '921.034-5',
    tipo: 'ESPONTANEO',
    estado: 'TRIAGEM',
    profissionalResponsavelId: null,
    consentimentoRegistrado: false,
    consentimentoData: null,
    indicadorPsicologicoAtual: 'ATIVO_BEM',
    indicadorSocialAtual: 'ATIVO_BEM',
    indicadorValidade: null,
    criadoEm: '2026-06-14T14:22:00Z',
    altaEm: null,
  },
  {
    id: 'c2e4d6f8-c3g5-5b7d-9f1e-2h4b6d8f0c1e',
    servidorId: 'c85d2c43-3995-67f4-c9ee-44df3h4de00d',
    nomeServidor: 'SD PM CARLOS HENRIQUE NEVES',
    matricula: '934.112-0',
    tipo: 'ENCAMINHADO_DISCIPLINAR',
    estado: 'TRIAGEM',
    profissionalResponsavelId: null,
    consentimentoRegistrado: false,
    consentimentoData: null,
    indicadorPsicologicoAtual: 'ATIVO_ALERTA_CRITICO',
    indicadorSocialAtual: 'ATIVO_MONITORADO',
    indicadorValidade: '2026-12-14',
    criadoEm: '2026-06-12T11:10:00Z',
    altaEm: null,
  },
  {
    id: 'd3f5e7g9-d4h6-6c8e-0g2f-3i5c7e9g1d2f',
    servidorId: 'd96e3d54-4006-78g5-d0ff-55eg4i5ef11e',
    nomeServidor: 'SGT PM JULIANA FERREIRA LIMA',
    matricula: '741.092-1',
    tipo: 'ESPONTANEO',
    estado: 'ALTA',
    profissionalResponsavelId: '7ccbc8cb-456c-48b2-11ee-33881dfdcc12',
    consentimentoRegistrado: true,
    consentimentoData: '2026-01-10T09:00:00Z',
    indicadorPsicologicoAtual: 'ATIVO_BEM',
    indicadorSocialAtual: 'ATIVO_BEM',
    indicadorValidade: '2026-12-31',
    criadoEm: '2026-01-10T08:00:00Z',
    altaEm: '2026-05-20T10:00:00Z',
  },
];

export const MOCK_PRONTUARIO: ProntuarioCompleto = {
  acolhimento: MOCK_ACOLHIMENTOS[0],
  plano: {
    id: '22ee11da-bc23-4e89-77ba-1122ccddee88',
    acolhimentoId: 'f8b2c8c4-e81a-4d22-bc55-1bdcf881ac33',
    objetivos:
      'Melhoria na qualidade do sono, acompanhamento social familiar e controle de ansiedade reativa.',
    periodicidade: 'QUINZENAL',
    dataInicio: '2026-05-20',
    dataRevisao: '2026-09-15',
  },
  sessoes: [
    {
      id: 'sess-001',
      acolhimentoId: 'f8b2c8c4-e81a-4d22-bc55-1bdcf881ac33',
      dataSessao: '2026-06-10T10:00:00Z',
      tipo: 'INDIVIDUAL',
      registro:
        'Paciente relata melhora progressiva na ansiedade; foco do plano em técnicas de respiração e reestruturação cognitiva.',
      profissionalId: '7ccbc8cb-456c-48b2-11ee-33881dfdcc12',
    },
    {
      id: 'sess-002',
      acolhimentoId: 'f8b2c8c4-e81a-4d22-bc55-1bdcf881ac33',
      dataSessao: '2026-05-26T10:00:00Z',
      tipo: 'INDIVIDUAL',
      registro:
        'Primeira sessão de acolhimento. Estabelecimento de vínculo terapêutico e levantamento de demandas iniciais. Boa adesão.',
      profissionalId: '7ccbc8cb-456c-48b2-11ee-33881dfdcc12',
    },
  ],
  encaminhamentos: [
    {
      id: '33aa12ff-d4ee-4889-bbba-c3344cc99aa9',
      acolhimentoId: 'f8b2c8c4-e81a-4d22-bc55-1bdcf881ac33',
      servidorId: 'a63b0a21-1773-45d2-a7cc-22bd1f2bc88b',
      origem: 'SAUDE',
      motivoCategoria: 'SAUDE_OCUPACIONAL',
      tipo: 'INTERNO',
      estado: 'TRIADO',
      criadoEm: '2026-05-14T14:20:00Z',
    },
  ],
};

export const MOCK_DASHBOARD: DashboardAgregado = {
  unidadeId: 'ca3a921d-91b4-4731-bf55-bc24718a221f',
  totalServidoresMapeados: 45,
  percentualAtivoBem: 80.0,
  percentualAtivoMonitorado: 15.6,
  percentualAtivoAlertaCritico: 4.4,
  comparativoHistorico: [
    {
      mesAno: '01/2026',
      percentualAtivoBem: 78.0,
      percentualAtivoMonitorado: 17.0,
      percentualAtivoAlertaCritico: 5.0,
    },
    {
      mesAno: '02/2026',
      percentualAtivoBem: 79.0,
      percentualAtivoMonitorado: 16.5,
      percentualAtivoAlertaCritico: 4.5,
    },
    {
      mesAno: '03/2026',
      percentualAtivoBem: 77.5,
      percentualAtivoMonitorado: 18.0,
      percentualAtivoAlertaCritico: 4.5,
    },
    {
      mesAno: '04/2026',
      percentualAtivoBem: 81.0,
      percentualAtivoMonitorado: 15.0,
      percentualAtivoAlertaCritico: 4.0,
    },
    {
      mesAno: '05/2026',
      percentualAtivoBem: 82.2,
      percentualAtivoMonitorado: 13.3,
      percentualAtivoAlertaCritico: 4.5,
    },
    {
      mesAno: '06/2026',
      percentualAtivoBem: 80.0,
      percentualAtivoMonitorado: 15.6,
      percentualAtivoAlertaCritico: 4.4,
    },
  ],
};
